export enum SystemRequestType {
  SYSTEM_REFRESH = 'system-refresh',
  SYSTEM_LOGOUT = 'system-logout',
  SYSTEM_DELETE = 'system-delete',
}
